import { render, staticRenderFns } from "./PreviewChooserText.vue?vue&type=template&id=cf98ae16&scoped=true&"
import script from "./PreviewChooserText.vue?vue&type=script&lang=ts&"
export * from "./PreviewChooserText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf98ae16",
  null
  
)

export default component.exports